import Module from '../utils/Module';
import gsap from 'gsap';

export default class PopupModule extends Module {
  constructor (options) {
    super(options);
    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);

    this.DOMEl = this.options.element;


    this.init();
  }

  init () {

  }

  openPopup(e) {

    const popup = e.querySelector(".popup")

    popup.style.display = 'block';

    document.body.classList.add("block-scroll");

    gsap.delayedCall(0.1, () =>{
      popup.classList.add('popup__opened')
    })
  }


  closePopup(e) {
    const popup = e.querySelector(".popup");

    popup.classList.remove('popup__opened')
    document.body.classList.remove("block-scroll");

    gsap.delayedCall(0.3, () =>{
      popup.style.display = 'none';
    });
  }
}
